"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Integration;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _common = require("@nestjs/common");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _extractProps = require("~/helpers/extractProps");
const _catchError = require("~/helpers/catchError");
const _modelUtils = require("~/utils/modelUtils");
const _utils = require("~/utils");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
const _integrations = /*#__PURE__*/ _interop_require_default(require("~/integrations"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('Integration');
let Integration = class Integration {
    static async init() {}
    static castType(integration) {
        return integration && new Integration(integration);
    }
    static encryptConfigIfRequired(obj) {
        obj.config = (0, _utils.encryptPropIfRequired)({
            data: obj
        });
        obj.is_encrypted = (0, _utils.isEncryptionRequired)();
    }
    static async createIntegration(integration, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(integration, [
            'title',
            'config',
            'type',
            'sub_type',
            'enabled',
            'meta',
            'created_by',
            'is_private',
            'is_default',
            'is_encrypted'
        ]);
        this.encryptConfigIfRequired(insertObj);
        if ('meta' in insertObj) {
            insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        }
        if (integration.workspaceId) insertObj.fk_workspace_id = insertObj.fk_workspace_id || integration.workspaceId;
        insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.INTEGRATIONS, insertObj.fk_workspace_id ? {
            fk_workspace_id: insertObj.fk_workspace_id
        } : {});
        if ((0, _nocodbsdk.integrationCategoryNeedDefault)(insertObj.type)) {
            // get if default integration exists for the type
            const defaultIntegration = await this.getCategoryDefault({
                workspace_id: insertObj.fk_workspace_id
            }, insertObj.type, ncMeta);
            // if default integration already exists then set is_default to false
            if (defaultIntegration) {
                insertObj.is_default = false;
            } else {
                insertObj.is_default = true;
            }
        }
        const { id } = await ncMeta.metaInsert2(insertObj.fk_workspace_id ? insertObj.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, insertObj);
        const int = await this.get({
            workspace_id: insertObj.fk_workspace_id
        }, id, false, ncMeta);
        return int;
    }
    static async updateIntegration(context, integrationId, integration, ncMeta = _Noco.default.ncMeta) {
        const oldIntegration = await Integration.get(context, integrationId, false, ncMeta);
        if (!oldIntegration) _catchError.NcError.integrationNotFound(integrationId);
        const updateObj = (0, _extractProps.extractProps)(integration, [
            'title',
            'type',
            'sub_type',
            'order',
            'enabled',
            'meta',
            'deleted',
            'config',
            'is_private',
            'is_default',
            'is_encrypted'
        ]);
        if (updateObj.config) {
            this.encryptConfigIfRequired(updateObj);
        }
        // type property is undefined even if not provided
        if (!updateObj.type) {
            updateObj.type = oldIntegration.type;
        }
        if ('meta' in updateObj) {
            updateObj.meta = (0, _modelUtils.stringifyMetaProp)(updateObj);
        }
        // if order is missing (possible in old versions), get next order
        if (!oldIntegration.order && !updateObj.order) {
            if (updateObj.order <= 1) {
                updateObj.order = 2;
            }
        }
        await ncMeta.metaUpdate(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, (0, _modelUtils.prepareForDb)(updateObj), oldIntegration.id);
        // call before reorder to update cache
        const int = await this.get(context, oldIntegration.id, false, ncMeta);
        return int;
    }
    static async setDefault(context, integrationId, ncMeta = _Noco.default.ncMeta) {
        const integration = await this.get(context, integrationId, false, ncMeta);
        if (!integration) {
            _catchError.NcError.integrationNotFound(integrationId);
        }
        // return if integration is already default
        if (integration.is_default) {
            return integration;
        }
        // get if default integration exists for the type
        const defaultIntegration = await this.getCategoryDefault({
            workspace_id: context.workspace_id
        }, integration.type, ncMeta);
        // if default integration already exists then set is_default to false
        if (defaultIntegration) {
            await ncMeta.metaUpdate(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, {
                is_default: false
            }, defaultIntegration.id);
        }
        await ncMeta.metaUpdate(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, {
            is_default: true
        }, integrationId);
        return await this.get(context, integrationId, false, ncMeta);
    }
    static async list(args, ncMeta = _Noco.default.ncMeta) {
        const qb = ncMeta.knex(_globals.MetaTable.INTEGRATIONS);
        // exclude integrations which are private and not created by user
        qb.where((whereQb)=>{
            whereQb.where(`${_globals.MetaTable.INTEGRATIONS}.is_private`, false).orWhereNull(`${_globals.MetaTable.INTEGRATIONS}.is_private`).orWhere(`${_globals.MetaTable.INTEGRATIONS}.created_by`, args.userId);
        });
        // if type is provided then filter integrations based on type
        if (args.type) {
            qb.where(`${_globals.MetaTable.INTEGRATIONS}.type`, args.type);
        }
        // if sub_type is provided then filter integrations based on sub_type
        if (args.sub_type) {
            qb.where(`${_globals.MetaTable.INTEGRATIONS}.sub_type`, args.sub_type);
        }
        qb.where((whereQb)=>{
            whereQb.where(`${_globals.MetaTable.INTEGRATIONS}.deleted`, false).orWhereNull(`${_globals.MetaTable.INTEGRATIONS}.deleted`);
        });
        if (args.query) {
            qb.where(`${_globals.MetaTable.INTEGRATIONS}.title`, 'like', `%${args.query}%`);
        }
        const listQb = qb.clone();
        if (args.includeSourceCount) {
            listQb.select(`${_globals.MetaTable.INTEGRATIONS}.*`, ncMeta.knex.raw(`count(${_globals.MetaTable.SOURCES}.id) as source_count`)).leftJoin(_globals.MetaTable.SOURCES, `${_globals.MetaTable.INTEGRATIONS}.id`, `${_globals.MetaTable.SOURCES}.fk_integration_id`).groupBy(`${_globals.MetaTable.INTEGRATIONS}.id`);
        }
        const integrationList = await listQb.orderBy(`${_globals.MetaTable.INTEGRATIONS}.order`, 'asc');
        // parse JSON metadata
        for (const integration of integrationList){
            integration.meta = (0, _modelUtils.parseMetaProp)(integration, 'meta');
        }
        const integrations = integrationList == null ? void 0 : integrationList.map((integrationData)=>{
            return this.castType(integrationData);
        });
        // if includeDatabaseInfo is true then get the database info for each integration
        if (args.includeDatabaseInfo) {
            for (const integration of integrations){
                const config = integration.getConfig();
                integration.config = (0, _utils.partialExtract)(config, [
                    'client',
                    [
                        'connection',
                        'database'
                    ],
                    // extract params related to sqlite
                    [
                        'connection',
                        'filepath'
                    ],
                    [
                        'connection',
                        'connection',
                        'filepath'
                    ],
                    [
                        'searchPath'
                    ]
                ]);
            }
        }
        return new _PagedResponse.PagedResponseImpl(integrations, {
            count: integrations.length,
            limit: integrations.length
        });
    }
    static async get(context, id, force = false, ncMeta = _Noco.default.ncMeta) {
        const integrationData = await ncMeta.metaGet2(context.workspace_id && context.workspace_id !== _globals.RootScopes.BYPASS ? context.workspace_id : _globals.RootScopes.BYPASS, context.workspace_id && context.workspace_id !== _globals.RootScopes.BYPASS ? _globals.RootScopes.WORKSPACE : _globals.RootScopes.BYPASS, _globals.MetaTable.INTEGRATIONS, id, null, force ? {} : {
            _or: [
                {
                    deleted: {
                        neq: true
                    }
                },
                {
                    deleted: {
                        eq: null
                    }
                }
            ]
        });
        if (integrationData) {
            integrationData.meta = (0, _modelUtils.parseMetaProp)(integrationData, 'meta');
        }
        return this.castType(integrationData);
    }
    async getConnectionConfig() {
        const config = this.getConfig();
        // todo: update sql-client args
        if ((config == null ? void 0 : config.client) === 'sqlite3') {
            var _config_connection;
            config.connection.filename = config.connection.filename || ((_config_connection = config.connection) == null ? void 0 : _config_connection.connection.filename);
        }
        return config;
    }
    getConfig() {
        const config = (0, _utils.decryptPropIfRequired)({
            data: this
        });
        return config;
    }
    async delete(ncMeta = _Noco.default.ncMeta) {
        const sources = await this.getSources(ncMeta, true);
        for (const source of sources){
            await source.delete({
                workspace_id: this.fk_workspace_id,
                base_id: source.base_id
            }, ncMeta);
        }
        // unbind all buttons and long texts associated with this integration
        await ncMeta.metaUpdate(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.COL_BUTTON, {
            fk_integration_id: null,
            model: null
        }, {
            fk_integration_id: this.id
        });
        await ncMeta.metaUpdate(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.COL_LONG_TEXT, {
            fk_integration_id: null,
            model: null
        }, {
            fk_integration_id: this.id
        });
        return await ncMeta.metaDelete(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, this.id);
    }
    async softDelete(ncMeta = _Noco.default.ncMeta) {
        const sources = await this.getSources(ncMeta, true);
        for (const source of sources){
            await source.softDelete({
                workspace_id: this.fk_workspace_id,
                base_id: source.base_id
            }, ncMeta);
        }
        // unbind all buttons and long texts associated with this integration
        await ncMeta.metaUpdate(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.COL_BUTTON, {
            fk_integration_id: null,
            model: null
        }, {
            fk_integration_id: this.id
        });
        await ncMeta.metaUpdate(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.COL_LONG_TEXT, {
            fk_integration_id: null,
            model: null
        }, {
            fk_integration_id: this.id
        });
        await ncMeta.metaUpdate(this.fk_workspace_id ? this.fk_workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, {
            deleted: true
        }, this.id);
    }
    async getSources(ncMeta = _Noco.default.ncMeta, force = false) {
        const qb = ncMeta.knex(_globals.MetaTable.SOURCES);
        qb.select(`${_globals.MetaTable.SOURCES}.id`).select(`${_globals.MetaTable.SOURCES}.alias`).select(`${_globals.MetaTable.PROJECT}.title as project_title`).select(`${_globals.MetaTable.SOURCES}.base_id`).innerJoin(_globals.MetaTable.PROJECT, `${_globals.MetaTable.SOURCES}.base_id`, `${_globals.MetaTable.PROJECT}.id`).where(`${_globals.MetaTable.SOURCES}.fk_integration_id`, this.id);
        if (!force) {
            qb.where((whereQb)=>{
                whereQb.where(`${_globals.MetaTable.SOURCES}.deleted`, false).orWhereNull(`${_globals.MetaTable.SOURCES}.deleted`);
            }).where((whereQb)=>{
                whereQb.where(`${_globals.MetaTable.PROJECT}.deleted`, false).orWhereNull(`${_globals.MetaTable.PROJECT}.deleted`);
            });
        }
        const sources = await qb;
        return this.sources = sources.map((src)=>new _models.Source(src));
    }
    static async getCategoryDefault(context, type, ncMeta = _Noco.default.ncMeta) {
        const integrationData = await ncMeta.metaGet2(context.workspace_id ? context.workspace_id : _globals.RootScopes.WORKSPACE, _globals.RootScopes.WORKSPACE, _globals.MetaTable.INTEGRATIONS, {
            type
        }, null, {
            _and: [
                {
                    is_default: {
                        eq: true
                    }
                },
                {
                    _or: [
                        {
                            deleted: {
                                neq: true
                            }
                        },
                        {
                            deleted: {
                                eq: null
                            }
                        }
                    ]
                }
            ]
        });
        if (integrationData) {
            integrationData.meta = (0, _modelUtils.parseMetaProp)(integrationData, 'meta');
        }
        return this.castType(integrationData);
    }
    static tempIntegrationWrapper(config) {
        const integrationWrapper = Integration.availableIntegrations.find((el)=>el.type === config.type && el.sub_type === config.sub_type);
        if (!integrationWrapper) {
            logger.error('Integration not found');
            _catchError.NcError._.internalServerError('Integration not found');
        }
        return new integrationWrapper.wrapper(config.config, {});
    }
    getIntegrationWrapper(pLogger) {
        if (!this.wrapper) {
            const IntegrationClass = this.constructor;
            const integrationWrapper = IntegrationClass.availableIntegrations.find((el)=>el.type === this.type && el.sub_type === this.sub_type);
            if (!integrationWrapper) {
                logger.error('Integration not found');
                _catchError.NcError._.internalServerError('Integration not found');
            }
            this.wrapper = new integrationWrapper.wrapper(this.getConfig(), {
                saveConfig: async (config)=>{
                    await IntegrationClass.updateIntegration({
                        workspace_id: this.fk_workspace_id
                    }, this.id, {
                        config
                    });
                },
                logger: pLogger
            });
            if (this.type === _nocodbsdk.IntegrationsType.Auth && this.wrapper && typeof this.wrapper.setTokenRefreshCallback === 'function') {
                this.wrapper.setTokenRefreshCallback(async (tokens)=>{
                    await IntegrationClass.updateIntegration({
                        workspace_id: this.fk_workspace_id
                    }, this.id, {
                        config: _extends({}, this.getConfig(), tokens)
                    });
                });
            }
        }
        return this.wrapper;
    }
    getIntegrationMeta() {
        const integrationMeta = Integration.availableIntegrations.find((el)=>el.type === this.type && el.sub_type === this.sub_type);
        if (!integrationMeta) {
            logger.error('Integration meta not found');
            _catchError.NcError._.internalServerError('Integration meta not found');
        }
        return integrationMeta == null ? void 0 : integrationMeta.manifest;
    }
    async storeInsert(context, fk_user_id, data, ncMeta = _Noco.default.ncMeta) {
        return await _models.IntegrationStore.insert(context, this, fk_user_id, data, ncMeta);
    }
    async storeList(context, limit, offset, ncMeta = _Noco.default.ncMeta) {
        return await _models.IntegrationStore.list(context, this, {
            limit,
            offset
        }, ncMeta);
    }
    async storeSum(context, fields, ncMeta = _Noco.default.ncMeta) {
        if (!Array.isArray(fields)) {
            fields = [
                fields
            ];
        }
        return await _models.IntegrationStore.sum(context, this, fields, ncMeta);
    }
    async storeGetLatest(context, ncMeta = _Noco.default.ncMeta) {
        return await _models.IntegrationStore.getLatest(context, this, ncMeta);
    }
    constructor(integration){
        Object.assign(this, integration);
    }
};
Integration.availableIntegrations = _integrations.default;
